import {useState, useEffect} from 'react';
import {useViewContext} from 'Contexts/ViewContext';
import {visitor} from 'rendition-core';
import axios from 'axios';

export const useGptRename = () => {
    const {view, updateView} = useViewContext();

    const [namingLoading, setNamingLoading] = useState(false);

    async function gptName(force = false) {
        try {
            if ((view && !view.meta.gptNamed) || force) {
                setNamingLoading(true);
                view.meta.gptNamed = true;
                const res = await axios.post(`compiler/gpt-name`, {view});
                const names = res.data;

                updateView((currentView) => {
                    visitor(currentView.tree, currentView.meta, (currentNode) => {
                        try {
                            if (names[currentNode.uniqueName]) {
                                currentNode.uniqueName = names[currentNode.uniqueName];
                            }

                            return {parent: currentNode};
                        } catch (e) {
                            console.log('failed to visit ', currentNode.uniqueName, '\n e ', e);
                            return {parent: currentNode};
                        }
                    });
                    return currentView;
                });

                setNamingLoading(false);
            }
        } catch (e) {
            console.log('failed to gpt name: ', e);
            setNamingLoading(false);
        }
    }

    useEffect(() => {
        gptName();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return {gptRename: () => gptName(true), gptRenameLoading: namingLoading};
};
